import { Module } from '../types/Module';
import { User } from '../types/User';

export const getUserData = (): User | null => {
  const userData = localStorage.getItem('user_data');
  if (userData) {
    try {
      const user = User.fromJson(JSON.parse(userData));
      return user;
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const setUserData = (user: User): void => {
  try {
    const userData = JSON.stringify(user.toJson());
    localStorage.setItem('user_data', userData);
  } catch (e) {}
};

export const removeUserData = (): void => {
  localStorage.removeItem('user_data');
};

export const getModuleData = (): Module | null => {
  const moduleData = localStorage.getItem('module_data');
  if (moduleData) {
    try {
      const module = Module.fromJson(JSON.parse(moduleData));
      return module;
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const setModuleData = (module: Module): void => {
  try {
    const moduleData = JSON.stringify(module.toJson());
    localStorage.setItem('module_data', moduleData);
  } catch (e) {}
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem('auth_token');
};

export const setAuthToken = (token: string): void => {
  localStorage.setItem('auth_token', token);
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('auth_token');
};

export const getStoreAuthToken = (): string | null => {
  return localStorage.getItem('store_auth_token');
};

export const setStoreAuthToken = (token: string): void => {
  localStorage.setItem('store_auth_token', token);
};

export const removeStoreAuthToken = (): void => {
  localStorage.removeItem('store_auth_token');
};

export const getReferralUser = (): string | null => {
  return localStorage.getItem('referral_user');
};

export const getDemoPlan = (): string | null => {
  return localStorage.getItem('demo_plan');
};
